import React from 'react'
import { IApplicationRoute } from './system/router'

import Landing from './pages/Landing'
import Login from './pages/Login'
import PublicVideoPage from './pages/PublicVideo'
import EmbedVideoPage from './pages/EmbedVideo'
import HomePage from './pages/Home'
import VideosPage from './pages/Videos'
import VideoPage from './pages/Video'

const routes: IApplicationRoute[] = [{
  name: 'landing',
  path: '/',
  meta: { title: 'Forum', public: true },
  render: () => <Landing />,
}, {
  name: 'login',
  path: '/login',
  meta: { title: 'Sign In', public: true },
  render: () => <Login />,
}, {
  // `:key` rather than `:id`: what a public link carries is a container KEY,
  // resolved by GET /public/containers/:key against a slug, a previous slug,
  // the container id, or any version's video id — a video id still works, it
  // is simply no longer the only thing that does. The pages read `params.key`.
  name: 'video',
  path: '/video/:key',
  meta: { title: 'Video', public: true },
  render: () => <PublicVideoPage />,
}, {
  // A deliberate link to one version of a container, by its zero-based index
  // in the on-chain version list. The page renders it and says plainly that
  // it is not the current one; nothing about playback changes, because a
  // superseded version's bytes are as authentic as the day they were sealed.
  name: 'video-version',
  path: '/video/:key/v/:index',
  meta: { title: 'Video', public: true },
  render: () => <PublicVideoPage />,
}, {
  name: 'embed',
  path: '/embed/:key',
  meta: { title: 'Forum', public: true },
  render: () => <EmbedVideoPage />,
}, {
  name: 'embed-version',
  path: '/embed/:key/v/:index',
  meta: { title: 'Forum', public: true },
  render: () => <EmbedVideoPage />,
}, {
  name: 'admin-home',
  path: '/admin/home',
  meta: { title: 'Home' },
  render: () => <HomePage />,
}, {
  name: 'admin-videos',
  path: '/admin/videos',
  meta: { title: 'Videos' },
  render: () => <VideosPage />,
}, {
  name: 'admin-video',
  path: '/admin/video/:id',
  meta: { title: 'Video' },
  render: () => <VideoPage />,
}]

export default routes
